import React, { useState } from 'react';
import { Button, Modal, Input, Alert, Space, Typography, message } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import UserSelect from './UserSelect';
import transferAdminService, { TRANSFER_TYPE_LABELS } from '../services/transferAdminService';

const { Text } = Typography;

/**
 * 管理员直接转移资源（无需对方接受，必须写原因，记入审计）。
 * props: type, id, name, size, onDone
 */
const AdminTransferAction = ({ type, id, name, size = 'small', onDone, children }) => {
    const [open, setOpen] = useState(false);
    const [toUser, setToUser] = useState(null);
    const [reason, setReason] = useState('');
    const [preview, setPreview] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const show = (e) => {
        e?.stopPropagation?.();
        setToUser(null); setReason(''); setPreview(null); setError('');
        setOpen(true);
    };

    const pick = async (uid) => {
        setToUser(uid); setPreview(null); setError('');
        if (!uid) return;
        try {
            setPreview(await transferAdminService.preview(type, id, String(uid)));
        } catch (e) {
            setError(e.error || '加载失败');
        }
    };

    const submit = async () => {
        setLoading(true); setError('');
        try {
            await transferAdminService.transfer(type, id, String(toUser), reason.trim());
            message.success('已转移');
            setOpen(false);
            onDone?.();
        } catch (e) {
            setError(e.error || '操作失败');
        } finally {
            setLoading(false);
        }
    };

    const blocked = !!preview?.blocker;
    return (
        <>
            {children ? <span onClick={show}>{children}</span> : (
                <Button size={size} icon={<SwapOutlined />} onClick={show}>转移</Button>
            )}
            {/* Modal 走 portal，但 React 事件仍沿组件树冒泡：挡住，免得触发表格行点击 */}
            <span onClick={(e) => e.stopPropagation()} role="presentation">
            <Modal
                open={open}
                title={`转移${TRANSFER_TYPE_LABELS[type] || '资源'}`}
                onCancel={() => setOpen(false)}
                destroyOnClose
                okText="直接转移"
                okButtonProps={{ disabled: !toUser || blocked || reason.trim().length < 2, loading, danger: true }}
                onOk={submit}
            >
                <Space direction="vertical" size={12} style={{ width: '100%' }} onClick={(e) => e.stopPropagation()}>
                    <Text strong>{preview?.resource?.name || name}</Text>
                    {preview?.owner && <Text type="secondary">当前所有者：{preview.owner.username} (#{preview.owner.id})</Text>}
                    <UserSelect value={toUser} onChange={pick} placeholder="接收账号" style={{ width: '100%' }} />
                    <Input.TextArea rows={2} maxLength={500} placeholder="原因（必填，记入审计）" value={reason} onChange={(e) => setReason(e.target.value)} />
                    {blocked && <Alert type="error" showIcon message={preview.blocker} />}
                    {!blocked && (preview?.warnings || []).length > 0 && (
                        <Alert type="warning" showIcon message={<div>{preview.warnings.map((w) => <div key={w}>{w}</div>)}</div>} />
                    )}
                    {error && <Alert type="error" showIcon message={error} />}
                </Space>
            </Modal>
            </span>
        </>
    );
};

export default AdminTransferAction;
